<!--
    Component used in the navbar to display days left for trial plans
 -->
<script setup lang="ts">
import { ALChip, ALPopover, ALTooltip, useCssBreakpoints } from '@af-lib/vue-ui';
import { computed, inject } from 'vue';
/* STORES */
import { useAuthStore } from '@/stores/auth';
/* TYPES */
import type { Translate } from '@/types/i18n/i18n.types';

const { isMobile } = useCssBreakpoints();
const t = inject('t') as Translate;

const store = useAuthStore();
// Init variables to calculate days left
const expiryDateTimestamp = store.getCompany.plan_expired_at;
const expiryDate = new Date(new Date(expiryDateTimestamp * 1000).setHours(0, 0, 0, 0));
const currentDate = new Date(new Date().setHours(0, 0, 0, 0));
const difference = expiryDate.getTime() - currentDate.getTime();
const daysLeft = Math.ceil(difference / (1000 * 3600 * 24)) + 1;

const tokensRemaining = computed(() => store.getCompany.tokens_remaining);
const overlayComponent = computed(() => (isMobile.value ? ALPopover : ALTooltip));
const overlayProps = computed(() =>
  isMobile.value
    ? {
        trigger: 'click',
        title: t('plans.trial.tokens_left', { token: tokensRemaining.value })
      }
    : {
        position: 'bottom',
        shouldTeleport: true
      }
);
</script>

<template>
  <div @click.stop>
    <component :is="overlayComponent" v-bind="overlayProps">
      <template #trigger>
        <ALChip
          size="s"
          icon="fat fa-coin"
          :label="`${t('plans.trial.tokens_left', { token: tokensRemaining })}`"
          class="border-af-teal-500 bg-af-teal-500 text-white"
        />
      </template>
      <template v-if="!isMobile" #content>
        <p>{{ $t('plans.trial.time_left', { days: daysLeft }) }}</p>
      </template>
      <template v-else #default>
        <p>{{ $t('plans.trial.time_left', { days: daysLeft }) }}</p>
      </template>
    </component>
  </div>
</template>
